import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '@adlatus-gui/domain/authentication';
import { KeycloakProfile } from 'keycloak-js';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { TagModule } from 'primeng/tag';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-user-profile-page',
  standalone: true,
  imports: [CommonModule, ButtonDirective, Ripple, TagModule, TranslatePipe],
  templateUrl: './user-profile-page.component.html',
  styleUrl: './user-profile-page.component.css'
})
export class UserProfilePageComponent {
  readonly $user!: Promise<KeycloakProfile>;
  readonly userRoles;

  constructor(private authenticationService: AuthenticationService) {
    this.$user = this.authenticationService.getUserProfile();
    this.userRoles = this.authenticationService.getUserRoles();
  }

  async changePassword() {
    await this.authenticationService.login({
      action: 'UPDATE_PASSWORD',
      redirectUri: window.location.href
    });
  }
}
